import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Switch from '@mui/material/Switch';
import React from 'react';
export default function SwitchExample() {
    const [state, setState] = React.useState({
        checkedA: true,
        checkedB: true,
    });
    const handleChange = (event) => {
        setState(Object.assign(Object.assign({}, state), { [event.target.name]: event.target.checked }));
    };
    return (_jsxs(FormGroup, Object.assign({ row: true }, { children: [_jsx(FormControlLabel, { control: _jsx(Switch, { checked: state.checkedA, onChange: handleChange, name: "checkedA" }), label: "Secondary" }), _jsx(FormControlLabel, { control: _jsx(Switch, { checked: state.checkedB, onChange: handleChange, name: "checkedB", color: "primary" }), label: "Primary" }), _jsx(FormControlLabel, { control: _jsx(Switch, {}), label: "Uncontrolled" }), _jsx(FormControlLabel, { disabled: true, control: _jsx(Switch, {}), label: "Disabled" }), _jsx(FormControlLabel, { disabled: true, control: _jsx(Switch, { checked: true }), label: "Disabled" })] })));
}
